import * as React from 'react';
import { Bank24 } from '@cian/ui-kit/icons';

import { IPromoBank } from '../../../../types/newbuilding/promos';
import * as styles from './BankIcon.css';

interface IBankIconProps {
  bank?: IPromoBank | null;
}

export function BankIcon({ bank }: IBankIconProps) {
  if (bank && (bank.logoUrl || bank.secondRoundImageUrl)) {
    return <img className={styles['logo']} src={bank.secondRoundImageUrl || bank.logoUrl} alt="" />;
  }

  return (
    <div className={styles['icon']}>
      <Bank24 />
    </div>
  );
}
